<woa-modal-page-layout [showHeader]="showHeader()" [showCloseButton]="showCloseButton()"
                       [title]="title()" [subtitle]="subtitle()" [contentText]="contentText()"
                       [translationParams]="translationParams()"
                       [showContent]="!!contentText() || checkboxes().length > 0"
                       [footerControlOrientation]="buttons().length <= 2 ? 'horizontal' : 'vertical'">
    @for (checkbox of checkboxes(); track checkbox) {
        <woa-selector-control class="simple-dialog-checkbox"
                              [label]="checkbox.label" [translationParams]="translationParams()"
                              [(selected)]="checkboxState[checkbox.name]"></woa-selector-control>
    }
    @for (button of buttons(); track button) {
        <woa-button woa-page-footer-control
                    [tier]="ButtonTier.FIRST" [prominence]="ButtonProminence.HIGH" [connotation]="button.connotation"
                    [label]="button.label" [translationParams]="translationParams()"
                    (onActivate)="buttonSelected(button.result)"></woa-button>
    }
</woa-modal-page-layout>
